import { render, staticRenderFns } from "./map-modal.vue?vue&type=template&id=c2906da4&scoped=true"
import script from "./map-modal.vue?vue&type=script&lang=ts"
export * from "./map-modal.vue?vue&type=script&lang=ts"
import style0 from "./map-modal.vue?vue&type=style&index=0&id=c2906da4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2906da4",
  null
  
)

export default component.exports